import { } from 'vue';
import SearchModel from '@Apps/Search/Src/Models/SearchModel';
import { fromUrlOrRewrite } from '@Apps/Search/Src/Logic/urlConvert';
import * as searchComposables from '@Composables/SearchComposables';


//import PagingModel from '@Apps/Search/Src/Models/PagingModel';
//import { FilterModel, FilterParamEntry } from '@Apps/Search/Src/Models/FilterModel';
//import { FilterSelectionDate, FilterSelectionLocation, FilterSelectionCompanions } from '@Types/FilterSelections';



export function setupSearchModel(): SearchModel {

    
    const searchModel = new SearchModel();

    for (let i = 0; i < searchComposables.getFilterDefinitions().criteriaGroupCount; i++) {

        searchModel.filter.criteria.push(new Array<number>());
    }

    // WRONG: setting non UI related data on filter, can trigger 
    // a watch update when changed after a fetch.
    // these properties should be set on a different object which is not watched.
    // e.g. not  the filter model, but a 'Search Model "?


    // total count can be read from 'global'
    searchModel.totalCount = searchComposables.getSearchBaseResultsFromServerSideRendering().totalCount;

    // paging init can also be read from global;
    searchModel.paging.page = searchComposables.getSearchBaseResultsFromServerSideRendering().page;
    searchModel.paging.pageCount = searchComposables.getSearchBaseResultsFromServerSideRendering().pageCount;
    searchModel.paging.pageSize = searchComposables.getSearchBaseResultsFromServerSideRendering().pageSize;



    fromUrlOrRewrite(searchModel.filter);

    return searchModel;
}



